import React from 'react';
import { ColorfulHorizontalLine } from '@epcbuilder/lib/components/Lines';
import PageSection from '../PageSection';

const sectionContainer = 'mx-6 sm:mx-8 md:mx-6 xl:mx-auto xl:w-11/12 xl:max-w-screen-2xl';
const headingClass = 'text-md text-2xl font-bold leading-tight md:text-[48px] xl:text-[64px]';
const subheadingClass = 'font-jost mb-4 text-[20px] font-medium md:text-[24px]';
const paragraphClass = 'leading-[28px] sm:leading-[30px] xl:text-[18px] xl:leading-9';

const TickIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="size-6 lg:size-9" viewBox="0 0 36 36" fill="none">
    <path
      d="M1.22852 17.6416C6.24531 23.0697 11.1095 27.9564 15.7853 34.1369C20.8689 24.026 26.072 13.8799 34.6572 2.89213L32.3439 1.83252C25.0947 9.52049 19.4627 16.7978 14.5689 25.4463C11.1658 22.3806 5.66594 18.0424 2.30781 15.8135L1.22852 17.6416Z"
      fill="#70AA80"
    />
  </svg>
);

const benefits = [
  {
    title: 'Prevent damp & mould',
    desc: 'Reducing condensation buildup.',
  },
  {
    title: 'Protect your insulation',
    desc: 'Ensures it doesn’t become a trap for moisture.',
  },
  {
    title: 'Improve indoor air quality',
    desc: 'Removes pollutants and maintains a healthy environment.',
  },
];

const installationSteps = [
  {
    step: '01',
    title: 'Clearing the Loft',
    desc: 'Any existing items or loft boards will need to be removed.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
        <path
          d="M47.2167 7.21689C48.2583 6.17523 48.2583 4.48356 47.2167 3.44189C46.175 2.40023 44.4833 2.40023 43.4417 3.44189L27.4417 19.4419L24.55 16.5502C24.2 16.2002 23.7167 16.0002 23.2167 16.0002C22.175 16.0002 21.3333 16.8419 21.3333 17.8836V20.3086L30.3583 29.3336H32.7833C33.825 29.3336 34.6667 28.4919 34.6667 27.4502C34.6667 26.9502 34.4667 26.4669 34.1167 26.1169L31.225 23.2252L47.225 7.22523L47.2167 7.21689ZM28.425 32.1169L18.55 22.2419C14.9917 21.9336 11.45 23.2169 8.9 25.7669L8.23333 26.4336C6.375 28.2919 5.33333 30.8086 5.33333 33.4336C5.33333 34.0002 5.925 34.3669 6.43333 34.1169L10.6917 31.9919C11.1083 31.7836 11.4833 32.3336 11.1417 32.6502L0.608333 42.1169C0.225 42.4669 0 42.9669 0 43.4919C0 44.5086 0.825 45.3336 1.84167 45.3336H16.2833C19.5167 45.3336 22.6083 44.0502 24.9 41.7669C27.45 39.2169 28.725 35.6752 28.425 32.1169Z"
          fill="#E76F51"
        />
      </svg>
    ),
    color: '#E76F51',
  },
  {
    step: '02',
    title: 'Loft Insulation Installation',
    desc: 'Insulation rolls are carefully placed between the joists.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
        <path
          d="M24 6C21.5156 6 19.5 8.01562 19.5 10.5V25.9219C19.5 27.5438 18.8344 28.9125 18.0656 29.9062C17.0812 31.1812 16.5 32.7656 16.5 34.5C16.5 38.6437 19.8562 42 24 42C28.1437 42 31.5 38.6437 31.5 34.5C31.5 32.7656 30.9188 31.1813 29.9344 29.9156C29.1656 28.9219 28.5 27.5531 28.5 25.9313V10.5C28.5 8.01562 26.4844 6 24 6ZM13.5 10.5C13.5 4.70625 18.1969 0 24 0C29.8031 0 34.5 4.69687 34.5 10.5V25.9219C34.5 25.9312 34.5094 25.95 34.5188 25.9781C34.5375 26.0344 34.5938 26.1281 34.6781 26.2406C36.45 28.5281 37.5 31.3969 37.5 34.5C37.5 41.9531 31.4531 48 24 48C16.5469 48 10.5 41.9531 10.5 34.5C10.5 31.3875 11.55 28.5187 13.3219 26.2406C13.4062 26.1281 13.4625 26.0344 13.4812 25.9781C13.4906 25.95 13.5 25.9312 13.5 25.9219V10.5ZM28.5 34.5C28.5 36.9844 26.4844 39 24 39C21.5156 39 19.5 36.9844 19.5 34.5C19.5 32.5406 20.7563 30.8719 22.5 30.2531V13.5C22.5 12.675 23.175 12 24 12C24.825 12 25.5 12.675 25.5 13.5V30.2531C27.2437 30.8719 28.5 32.5406 28.5 34.5Z"
          fill="#F0935C"
        />
      </svg>
    ),
    color: '#F0935C',
  },
  {
    step: '03',
    title: 'Ventilation Installation',
    desc: 'Extractor fans or trickle vents are fitted as needed.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
        <g clipPath="url(#clip0_4512_55996)">
          <path
            d="M24.2438 0C24.0844 0 23.925 0.009375 23.7656 0.046875C15.75 1.59375 10.8375 9.59063 12.2344 17.7469C12.5063 19.3406 13.0219 20.8312 13.725 22.1906L3 21H2.75625C1.2375 21 0 22.2375 0 23.7562C0 23.9156 0.009375 24.075 0.046875 24.2344C1.59375 32.25 9.59063 37.1625 17.7469 35.7656C19.3406 35.4938 20.8312 34.9781 22.1906 34.275L21 45V45.2438C21 46.7625 22.2375 48 23.7562 48C23.9156 48 24.075 47.9906 24.2344 47.9531C32.25 46.4062 37.1625 38.4094 35.7656 30.2531C35.4938 28.6594 34.9781 27.1687 34.275 25.8094L45 27H45.2438C46.7625 27 48 25.7625 48 24.2438C48 24.0844 47.9906 23.925 47.9531 23.7656C46.4062 15.75 38.4094 10.8375 30.2531 12.2344C28.6594 12.5063 27.1687 13.0219 25.8094 13.725L27 3V2.75625C27 1.2375 25.7625 0 24.2438 0ZM24 21C24.7956 21 25.5587 21.3161 26.1213 21.8787C26.6839 22.4413 27 23.2044 27 24C27 24.7956 26.6839 25.5587 26.1213 26.1213C25.5587 26.6839 24.7956 27 24 27C23.2044 27 22.4413 26.6839 21.8787 26.1213C21.3161 25.5587 21 24.7956 21 24C21 23.2044 21.3161 22.4413 21.8787 21.8787C22.4413 21.3161 23.2044 21 24 21Z"
            fill="#EBBC67"
          />
        </g>
        <defs>
          <clipPath id="clip0_4512_55996">
            <rect width="48" height="48" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    color: '#EBBC67',
  },
  {
    step: '04',
    title: 'Loft Boarding Replacement',
    desc: 'If loft boards were removed, they will be reinstalled using loft board stilts to ensure the boards sit level above the insulation.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
        <path
          d="M27.5883 24.0844L22.4864 18.9834C22.3819 18.8786 22.2577 18.7954 22.121 18.7386C21.9842 18.6818 21.8376 18.6526 21.6896 18.6526C21.5415 18.6526 21.3949 18.6818 21.2581 18.7386C21.1214 18.7954 20.9972 18.8786 20.8927 18.9834L1.16674 37.5938C1.05735 37.6969 0.969743 37.8209 0.909091 37.9585C0.84844 38.096 0.815975 38.2443 0.813615 38.3947C0.811255 38.545 0.839049 38.6943 0.895353 38.8336C0.951657 38.973 1.03533 39.0997 1.14143 39.2063L7.33361 45.42C7.43991 45.5266 7.56653 45.6108 7.70596 45.6676C7.8454 45.7244 7.99482 45.7527 8.14536 45.7506C8.29591 45.7486 8.44452 45.7164 8.58239 45.6559C8.72026 45.5954 8.84458 45.5079 8.94799 45.3984L27.5864 25.6772C27.6913 25.5728 27.7745 25.4488 27.8314 25.3122C27.8883 25.1756 27.9176 25.0291 27.9178 24.8812C27.918 24.7332 27.8889 24.5867 27.8324 24.45C27.7759 24.3132 27.6929 24.189 27.5883 24.0844ZM46.8117 18.6872L42.6971 14.6016C42.5089 14.414 42.2854 14.2656 42.0395 14.1648C41.7936 14.0641 41.5303 14.0131 41.2646 14.0147C40.834 14.0151 40.4146 14.1509 40.0655 14.4028C40.0655 14.3625 40.0711 14.3231 40.0739 14.2884C40.1161 13.6791 40.1817 12.7584 39.5864 11.9241C38.8786 10.9701 38.1015 10.0695 37.2614 9.2297C37.2592 9.22697 37.2567 9.22446 37.2539 9.2222C36.0052 7.9922 33.2874 5.67563 29.1239 3.97782C27.5442 3.33019 25.8531 2.99801 24.1458 3.00001C21.1871 3.00001 18.9371 4.33501 18.0755 5.12626C17.2271 5.90041 16.6707 6.94274 16.4996 8.07845L17.9996 9.00001C17.9996 9.00001 18.7552 8.81251 19.2989 8.6822C19.867 8.56104 20.4499 8.5247 21.0286 8.57438C22.2652 8.67657 23.7277 9.29063 24.3746 9.80157C25.4714 10.6838 25.9992 11.8725 26.0864 13.6538C26.1052 14.0503 25.1939 15.6553 23.8214 17.3888C23.7073 17.5329 23.65 17.7139 23.6606 17.8975C23.6711 18.081 23.7487 18.2543 23.8786 18.3844L28.1321 22.6378C28.2683 22.7729 28.4512 22.8506 28.643 22.855C28.8348 22.8593 29.021 22.79 29.1633 22.6613C30.2949 21.63 32.0217 20.0363 32.4136 19.7934C33.1346 19.35 33.6502 19.2647 33.7917 19.2497C34.1591 19.2137 34.5286 19.2916 34.8502 19.4728C34.8518 19.4889 34.85 19.5051 34.845 19.5204C34.84 19.5357 34.8319 19.5499 34.8211 19.5619L34.6505 19.7241L34.6224 19.7503C34.4338 19.9382 34.2843 20.1614 34.1825 20.4073C34.0806 20.6531 34.0284 20.9167 34.0288 21.1829C34.0292 21.449 34.0823 21.7124 34.185 21.9579C34.2877 22.2034 34.4379 22.4262 34.6271 22.6134L38.7474 26.7084C38.8879 26.8481 39.078 26.9265 39.2761 26.9265C39.4743 26.9265 39.6643 26.8481 39.8049 26.7084L46.8061 19.7522C46.8768 19.6828 46.933 19.6002 46.9716 19.509C47.0101 19.4178 47.0303 19.3199 47.0308 19.2209C47.0313 19.1219 47.0122 19.0237 46.9746 18.9321C46.937 18.8405 46.8817 18.7573 46.8117 18.6872Z"
          fill="#70AA80"
        />
      </svg>
    ),
    color: '#70AA80',
  },
];
const LoftInsulationPage = () => {
  return (
    <div className="flex min-h-screen flex-col gap-10 bg-white lg:gap-12 xl:gap-16">
      <div id="finance-intro" className={`${sectionContainer} mt-10 flex flex-col gap-4 md:mt-12 lg:gap-6`}>
        <h2 className={headingClass}>Loft Insulation Information</h2>
        <p className="font-jost text-[#516B75] md:text-[20px] xl:text-[24px]">
          Improve energy efficiency and reduce heat loss
        </p>
      </div>

      <PageSection title="About Knauf" containerClassName={sectionContainer}>
        <div className="flex flex-col gap-4 xl:gap-6">
          <p className={paragraphClass}>
            Knauf is a UK-based company that began in 1988 and has grown into a global industry leader. Through
            state-of-the-art manufacturing, Knauf produces high-performance insulation products designed to enhance
            thermal efficiency and soundproofing in homes.
          </p>
        </div>
      </PageSection>

      <div className="bg-[#F8F9FA]">
        <div className={`${sectionContainer} m-6 flex flex-col gap-6 md:flex-row md:items-center`}>
          <div className="md:w-1/2">
            <h2 className="mb-2 font-[unset] text-lg font-black uppercase sm:mb-4 md:text-[22px] xl:text-2xl">
              About Mineral Wool
            </h2>
            <ColorfulHorizontalLine width="10rem" />
            <p className={`mr-6 mt-4 md:max-w-[552px] ${paragraphClass}`}>
              Mineral Wool is made from volcanic rock or glass that has been heated and spun into thin fibres, creating
              a highly effective thermal and acoustic insulation material. It is commonly supplied in large rolls, which
              are placed between loft joists to retain heat and reduce energy costs.
            </p>
          </div>
          <div className="flex flex-col gap-6 md:w-1/2 md:px-6">
            {['knauf-insulation-logo.png', 'knauf-insulation.png'].map((img, i) => (
              <div
                key={i}
                className={`h-[${i === 0 ? 50 : 200}px] w-full bg-contain bg-no-repeat ${
                  i === 0 ? 'bg-left' : 'bg-center'
                } md:max-w-[${i === 0 ? 130 : 323}px]`}
                style={{
                  backgroundImage: `url('/images/${img}')`,
                  backgroundColor: '#F8F9FA',
                  backgroundBlendMode: 'darken',
                }}
              />
            ))}
            <div>
              <p className={`font-bold ${paragraphClass}`}>Knauf</p>
              <p className={`text-[#516B75] ${paragraphClass}`}>Mineral Wood</p>
            </div>
          </div>
        </div>
      </div>

      <PageSection title="Ventilation & Your Home" containerClassName={sectionContainer}>
        <div className="flex flex-col gap-8 md:flex-row lg:gap-12 xl:gap-20">
          <div className="md:w-1/2">
            <p className={subheadingClass}>Why Ventilation Is Important</p>
            <p className={`mb-4 ${paragraphClass}`}>
              Proper ventilation plays a crucial role in maintaining a healthy home environment. It helps to:
            </p>
            <ul className="space-y-4">
              {benefits.map(({ title, desc }) => (
                <li key={title} className="flex items-center gap-3">
                  <div className="w-8">
                    <TickIcon />
                  </div>
                  <div>
                    <p className={`font-semibold ${paragraphClass}`}>{title}</p>
                    <p className={`text-[#516B75] ${paragraphClass}`}>{desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:w-1/2">
            <p className={subheadingClass}>Ventilation During Installation</p>
            <p className={paragraphClass}>
              When installing Loft Insulation, additional ventilation may be required. This may include:
            </p>
            <ul className="list-inside list-disc space-y-2">
              <li className={paragraphClass}>Extractor fans - To enhance airflow and reduce humidity.</li>
              <li className={paragraphClass}>
                Trickle vents - Installed on windows to allow continuous air circulation.
              </li>
            </ul>
            <p className={paragraphClass}>
              The type of ventilation needed depends on your property, and our team will assess this during
              installation.
            </p>
          </div>
        </div>
      </PageSection>

      <PageSection title="Installation" containerClassName={sectionContainer}>
        <div className="mb-10 flex flex-col gap-10 lg:flex-row xl:mb-20 xl:gap-20">
          <div className="lg:w-1/2">
            <p className="font-jost mb-4 text-[20px] font-medium md:text-[24px]">Installation Steps</p>
            <div className="flex flex-col gap-4">
              {installationSteps.map(({ step, title, desc, icon, color }) => (
                <div
                  key={step}
                  className="flex w-full items-center gap-4 rounded-[10px] bg-white p-4 lg:rounded-[20px]"
                  style={{
                    boxShadow: '0px 0px 10px 0px rgba(21, 53, 66, 0.15)',
                    alignSelf: 'stretch',
                  }}
                >
                  <div className="mr-4 text-center">
                    <p className="text-[17px] font-extrabold text-[#748991] xl:text-[19px]">STEP</p>
                    <p
                      className="text-[40px] font-[900] leading-[50px] xl:text-[48px]"
                      style={{
                        color,
                      }}
                    >
                      {step}
                    </p>
                  </div>
                  <div className="flex-1">
                    <p className={`font-semibold ${paragraphClass}`}>{title}</p>
                    <p className={`text-[#516B75] ${paragraphClass}`}>{desc}</p>
                  </div>
                  <div className="ml-4 hidden text-2xl sm:flex">{icon}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="lg:w-1/2">
            <p className="font-jost mb-4 text-[20px] font-medium md:text-[24px]">Installation Duration</p>
            <p className={`mb-6 ${paragraphClass}`}>
              Installing Loft Insulation typically takes 1-2 days, including any necessary ventilation work.
            </p>
            <p className="font-jost mb-4 text-[20px] font-medium md:text-[24px]">Warranties & Guarantees</p>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <TickIcon />
                <p>Manufacturer Warranty</p>
              </li>
              <li className="flex items-center gap-3">
                <TickIcon />
                <p>Material & Workmanship Guarantee</p>
              </li>
              <li className="flex items-center gap-3">
                <TickIcon />
                <p>Insurance Backed Guarantee</p>
              </li>
            </ul>
          </div>
        </div>
      </PageSection>
    </div>
  );
};

export default LoftInsulationPage;
